import { wrapTranslationsSchema } from '../../helpers/i18n/wrapTranslationsSchema';

export const HeaderTranslations = wrapTranslationsSchema({
	name: 'HeaderTranslations',
	title: 'Header Translations',
	sanityId: 'header',
	fields: {
		cartTitle: 'Cart',
		stores: 'Stores',
		favorites: 'Favorites',
		savedForLater: 'Saved for later',
		seeAllStores: 'See all Stores...',
		search: 'Search',
		menu: 'Menu',
		languages: 'Languages',
		profile: 'Profile',
	},
});
